export default "__VITE_ASSET__X78vQgZZ__"